module.exports = __webpack_public_path__ + "static/media/sonder6.5ddc1c1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder6.jpg
// module id = 385
// module chunks = 0